import mutations from './mutations'
import actions from "./actions";
const authRoutes = {
    namespaced: true,
    state: {
        regionList: [], // 库区
    },
    mutations,
    actions
}
export default authRoutes